<button mat-icon-button [matMenuTriggerFor]="menu" (click)="$event.stopPropagation()">
  <icon-outline icon="more_vert" />
</button>

<mat-menu #menu="matMenu">
  <button mat-menu-item [disabled]="!cellValue.readyToExecute" (click)="run()">
    <mat-icon>bolt</mat-icon>
    <span>{{ 'ORDERS.RUN' | translate }}</span>
  </button>
  <button mat-menu-item [disabled]="!canBeCancel()" (click)="cancel()">
    <mat-icon>close</mat-icon>
    <span>{{ 'CANCEL' | translate }}</span>
  </button>
  <button mat-menu-item [disabled]="!canAddUsers" (click)="addUsers()">
    <mat-icon>person_add_alt</mat-icon>
    <span>{{ 'ORDERS.ADD_INSPECTORS' | translate }}</span>
  </button>
  <button [disabled]="!canViewOrderCard" mat-menu-item (click)="showOrderCardDialog()">
    <mat-icon>assignment</mat-icon>
    <span>{{ 'ORDERS.KOL' | translate }}</span>
  </button>
  <button [disabled]="!canClose" mat-menu-item (click)="close()">
    <mat-icon>delete_forever</mat-icon>
    <span>{{ 'ORDERS.CLOSE' | translate }}</span>
  </button>
  <button mat-menu-item [disabled]="!canDownloadZip" (click)="downloadZip()">
    <mat-icon>download</mat-icon>
    <span>{{ 'ORDERS.DOWNLOAD_ZIP' | translate }}</span>
  </button>
  <button *ngIf="store.isAdmin()" mat-menu-item [disabled]="!canPushToPse" (click)="pushToPse()">
    <mat-icon>send</mat-icon>
    <span>{{ 'ORDERS.PUSH_TO_PSE' | translate }}</span>
  </button>
</mat-menu>
